import {RouterProps} from "../../RouterProps";
import {useParams} from "react-router-dom";
import {useStatePair} from "react-type-extension";
import {UserSignInVerboseValueObject} from "../../../data/value-object/user/UserSignInVerboseValueObject";
import {useEffect} from "react";
import {UserSignInIO} from "../../../io/UserIO";
import {Body1, Caption1Strong, Spinner, Tab, TabList} from "@fluentui/react-components";
import {UserSignInDomain} from "../../../data/domain/user/UserSignInDomain";
import {UserSignInDescriptor} from "../../../data/descriptor/user/UserSignInDescriptor";
import {mapByKey} from "../../../util/ObjectUtil";
import {UserSignInDescription} from "../../../data/description/user/UserSignInDescription";

enum Panel {
    Default,
}

export default function Detail(props: RouterProps) {
    const params = useParams<{ userSignInId: string }>()
    const item = useStatePair<UserSignInVerboseValueObject | undefined>(undefined)

    useEffect(() => {
        if (item.value === undefined && params.userSignInId !== undefined) {
            UserSignInIO
                .getVerboseById(BigInt(params.userSignInId))
                .then(item.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
        }
    }, []);

    return <>
        {item.value === undefined && <Spinner />}
        {item.value !== undefined && <Page {...props} item={item.value} /> }
    </>
}

type PageProps = RouterProps & {
    item: UserSignInVerboseValueObject
}

function Page(props: PageProps) {
    const panel = useStatePair<Panel>(Panel.Default)
    return <>
        <div className={props.styles.row16}>
            <TabList
                selectedValue={panel.value}
                onTabSelect={(_, data) => panel.setter(data.value as Panel)}
                vertical>
                <Tab value={Panel.Default}>상세</Tab>
            </TabList>
            <DefaultPanel
                {...props}
                panel={panel.value} />
        </div>
    </>
}

type PropertyBodyProps = PageProps & {
    itemKey: keyof UserSignInDomain
}

function PropertyBody(props: PropertyBodyProps) {
    switch (props.itemKey) {
        case "id":
        case "remoteAddress":
        case "deviceName":
        case "deviceVersion":
        case "createdAt":
            return <Body1>{UserSignInDescriptor[props.itemKey](props.item)}</Body1>
        case "userId":
            return props.item.userId !== undefined
                ? <a href={`/users/${props.item.userId}`}><Body1>{UserSignInDescriptor[props.itemKey](props.item)}</Body1></a>
                : <Body1>-</Body1>
        case "envClientId":
            return props.item.envClientId !== undefined
                ? <a href={`/env/clients/${props.item.envClientId}`}><Body1>{UserSignInDescriptor[props.itemKey](props.item)}</Body1></a>
                : <Body1>-</Body1>
    }
}

type PanelProps = PageProps & {
    panel: Panel
    children?: false | JSX.Element | JSX.Element[]
}

function DefaultPanel(props: PanelProps) {
    return <>
        {props.panel === Panel.Default && <>
            <div className={props.styles.column16}>
                {mapByKey(UserSignInDescription, key => <>
                    <div className={props.styles.column4}>
                        <Caption1Strong>{UserSignInDescription[key]}</Caption1Strong>
                        <PropertyBody
                            {...props}
                            itemKey={key}/>
                    </div>
                </>)}
                {props.children}
            </div>
        </>}
    </>
}